document.addEventListener("DOMContentLoaded", () => {
  // Define the total number of stars
  const totalStars = 5;

  // SVG for the filled star
  const filledStarSVG = `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 .587l3.668 7.568 8.332 1.226-6 5.85 1.416 8.256-7.416-3.9-7.416 3.9 1.416-8.256-6-5.85 8.332-1.226z"/>
        </svg>
    `;

  // SVG for the blank star
  const blankStarSVG = `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2l2.39 4.85L20 8.75l-3.64 3.54L17.07 18 12 14.27 6.93 18 8.64 12.29 5 8.75l5.61-.9L12 2z"/>
        </svg>
    `;

  // Get all label elements with a "for" attribute starting with "Filter-Rating-"
  const labels = document.querySelectorAll('label[for^="Filter-Rating-"]');

  labels.forEach((label) => {
    // Get the associated input element by finding the input inside the same parent container
    const input = label
      .closest(".faceted-filter-group-display__list-item")
      .querySelector(".faceted-filter-group-display__list-item-input");

    if (input) {
      const rating = parseInt(input.value, 10);

      // Create a container for the stars
      const starsContainer = document.createElement("span");

      // Add filled stars based on the input value
      for (let i = 0; i < rating; i++) {
        const starSpan = document.createElement("span");
        starSpan.innerHTML = filledStarSVG; // Use SVG for filled star
        starSpan.style.marginRight = "2px"; // Optional: Add some spacing between the stars
        starsContainer.appendChild(starSpan);
      }

      // Add blank stars to fill up to the total number of stars
      for (let i = rating; i < totalStars; i++) {
        const blankStarSpan = document.createElement("span");
        blankStarSpan.innerHTML = blankStarSVG; // Use SVG for blank star
        blankStarSpan.style.marginRight = "2px"; // Optional: Add some spacing between the stars
        starsContainer.appendChild(blankStarSpan);
      }

      // Insert the stars container before the text of the label
      const textSpan = label.querySelector(
        ".faceted-filter-group-display__list-item-label-text"
      );
      if (textSpan) {
        label.insertBefore(starsContainer, textSpan);
      }
    }
  });
});


$(document).ready(function () {
  function initializeSlider() {
    // Destroy the existing slider instance if it exists
    if ($(".jdgm-rev-widg__reviews").hasClass("slick-initialized")) {
      $(".jdgm-rev-widg__reviews").slick("unslick");
    }

    // Initialize the slider
    let w = $(window).width();
    if (w <= 750) {
      $(".jdgm-rev-widg__reviews").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        speed: 500,
        autoplay: true,
        arrows: true,
        // responsive: [
        //   {
        //     breakpoint: 1024, // Screen width in pixels
        //     settings: {
        //       slidesToShow: 3,
        //       slidesToScroll: 1,
        //     },
        //   },
        //   {
        //     breakpoint: 768, // Screen width in pixels
        //     settings: {
        //       slidesToShow: 2,
        //       slidesToScroll: 1,
        //     },
        //   },
        //   {
        //     breakpoint: 0, // Screen width in pixels
        //     settings: "unslick",
        //   },
        //   // You can add more breakpoints if needed
        // ],
      });
    }
  }

  // Initial setup
  initializeSlider();


  // Reinitialize on window resize
  $(window).resize(function () {
    initializeSlider();
  });
});

// Flickity Scrollbar Code

// Initialize Flickity on the slider
document.addEventListener("DOMContentLoaded", function () {
  // Delay the execution to ensure all elements are fully loaded
  setTimeout(function () {
    // Ensure Flickity is correctly included in your project
    if (typeof Flickity === "undefined") {
      console.error("Flickity is not loaded");
      return;
    }

    // Initialize Flickity on the correct container with the 'contain' option
    var carouselElement = document.querySelector(".product_gallery");

    if (!carouselElement) {
      console.error("Carousel element not found.");
      return;
    }

    var flkty = new Flickity(carouselElement, {
      contain: true, // Ensures the cells are aligned to the left
       cellAlign: 'left', 
    });

    // Target the custom scrollbar element
    var scrollBar = document.querySelector(".scroll-bar");

    if (!scrollBar) {
      console.error("Scroll bar element not found.");
      return;
    }

    // Update the scrollbar width on slide change
    function updateScrollbar() {
      var totalSlides = flkty.slides.length;
      var currentIndex = flkty.selectedIndex;
      var progress = (currentIndex + 1) / totalSlides;
      var totalWidth = document.querySelector(".custom-scrollbar").offsetWidth;
      scrollBar.style.width = progress * totalWidth + "px";
    }

    // Initial update
    updateScrollbar();

    // Attach event listeners
    flkty.on("change", updateScrollbar);

    // Optional: If you want to track the scroll event
    flkty.on("scroll", function (progress) {
      var totalWidth = document.querySelector(".custom-scrollbar").offsetWidth;
      var maxProgress = 1; // Adjust as needed if your progress needs scaling
      scrollBar.style.width =
        Math.max(0, Math.min(progress * totalWidth, totalWidth)) + "px";
    });

    // Adjust carousel cells to show 1.5 images and align left
    function adjustCarousel() {
      if (window.innerWidth <= 750) {
        var carousel = document.querySelector(".product_gallery .flickity-slider");
        var carouselCells = carousel.querySelectorAll(".product_gallery .flickity-slider .gallery-cell");
        var carouselWidth = carousel.offsetWidth;

        // Calculate the width for 1.5 images
        var cellWidth = carouselWidth / 1.3;

        // Set the width for each carousel cell
        carouselCells.forEach(function (cell) {
          cell.style.width = cellWidth + "px";
        });

        // Resize Flickity
        flkty.resize();
      }
    }

    // Call the function to adjust carousel on load
    adjustCarousel();

    // Add event listener to adjust carousel on window resize
    window.addEventListener("resize", adjustCarousel);
  }, 100); // Adjust the delay as needed
});

window.onload = function() {
    var css = '.payment-terms-container { display: none; }';
    var style = document.createElement('style');
    style.type = 'text/css';
    
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
    
    document.getElementsByTagName('head')[0].appendChild(style);
};

let chatBox = false;

const applyChatButtonStyles = (chat_btn) => {
  if (chat_btn) {
    chat_btn.style.borderRadius = '0';
    chat_btn.style.height = '40px';
    chat_btn.style.width = '40px';
  }
};

const observer = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
    // Check for changes in the cart-drawer id or class
    if (mutation.type === 'attributes' && (mutation.attributeName === 'id' || mutation.attributeName === 'class')) {
      // handleCartDrawerState();  // Uncomment this if needed
    }

    // Check for the addition of the Shopify chat widget only if it hasn't been found yet
    if (!chatBox && mutation.type === 'childList') {
      const chat_btn = document.querySelector('#shopify-chat');
      const vip_text_club = document.querySelector('.sc-1lt4kt8-0');
      
      const earnReward = document.querySelector('#earnRewards');
      const jdgm_btn = document.querySelector('.jdgm-revs-tab-btn');
      let mobileWrapper = document.querySelector('.mobile-wrapper');
      const footer = document.querySelector('footer');

      if (chat_btn) {
        //applyChatButtonStyles(chat_btn); // Apply CSS styles to chat_btn
      }

      if (vip_text_club) {
        chatBox = true;
        console.log("Found");

        if (window.innerWidth <= 750) {
          // Create .mobile-wrapper if it doesn't exist
          if (!mobileWrapper) {
            if (footer) {
              mobileWrapper = document.createElement('div');
              mobileWrapper.className = 'mobile-wrapper';
              footer.appendChild(mobileWrapper);
            } else {
              console.warn('Footer element not found.');
              return;
            }
          }
          if (chat_btn) mobileWrapper.appendChild(chat_btn);
          if (vip_text_club) mobileWrapper.appendChild(vip_text_club);
          if (earnReward) mobileWrapper.appendChild(earnReward);
          if (jdgm_btn) mobileWrapper.appendChild(jdgm_btn);
        } else {
          if (mobileWrapper) {
            if (chat_btn) document.body.appendChild(chat_btn);
            if (vip_text_club) document.body.appendChild(vip_text_club);
            if (earnReward) document.body.appendChild(earnReward);
            if (jdgm_btn) document.body.appendChild(jdgm_btn);
            mobileWrapper.remove();
            console.log('Removed mobile-wrapper');
          }
        }
      }
    }
  }
});

observer.observe(document.body, {
  attributes: true,
  childList: true, 
  subtree: true  
});

  $(".refine-search-box-mobile .sidebar-block__heading").on("click", function (e) {
    $(this).parent().toggleClass("visible-toggle");
    // $(this).siblings('.sidebar').toggleClass('showChild');
    $(this).siblings('.sidebar').slideToggle('');
   $(this).siblings().find('details').removeAttr('open');
  });
 $("details.sidebar-block").on("click", function (e) {

 });



document.addEventListener('DOMContentLoaded', function() {
    // Check if the user is on a mobile device
    const isMobile = window.innerWidth <= 768; // Adjust the width as needed for your definition of mobile

    if (isMobile) {
        document.querySelectorAll('.faceted-filter-group-display__list-item-label input[type="checkbox"]').forEach(input => {
            input.addEventListener('click', function(event) {
                const label = this.closest('.faceted-filter-group-display__list-item-label');
                if (label) {
                    // Manually trigger a click on the label
                    label.click();
                }
            });
        });
    }
});


document.addEventListener('click', function() {
  const chatIcon = document.querySelector('#ShopifyChat[is-open]');
  if (chatIcon && chatIcon.getAttribute('is-open') === 'false') {
    const parentDiv = chatIcon.closest('#shopify-chat');
    if (parentDiv) {
      parentDiv.style.zIndex = '2';
    }
  } else {
    const parentDiv = chatIcon.closest('#shopify-chat');
    if (parentDiv) {
      parentDiv.style.zIndex = 'unset';
    }
  }
});
